const user_group_name = {
    'ATC': 'ATC'
};

export default user_group_name;
